export default __webpack_public_path__ + "static/media/red-alignment.0b300b23.svg";